<template>
  <el-card class="user-content-panel">
    <div slot="header">
      <span class="panel-header">常见问题</span>
    </div>

    <el-collapse class="quesion-list">
      <el-collapse-item v-for="question in questionList" :key="question.questionId">
        <template slot="title">
          <div class="question-title">{{ question.title }}</div>
        </template>
        <div class="question-answer">{{ question.answer }}</div>
      </el-collapse-item>
    </el-collapse>
  </el-card>
</template>

<script>
export default {
  name: 'faq',
  data () {
    return {
      questionList: [
        {
          questionId: '1',
          title: '没有POCM+账号怎么办？',
          answer: '问题回答，测试数据。问题回答，测试数据。问题回答，测试数据。问题回答，测试数据。问题回答，测试数据。'
        },
        {
          questionId: '2',
          title: '我在POCM+可以获得什么？',
          answer: '问题回答，测试数据。问题回答，测试数据。问题回答，测试数据。问题回答，测试数据。问题回答，测试数据。'
        },
        {
          questionId: '3',
          title: '如何新建地址？',
          answer: '问题回答，测试数据。问题回答，测试数据。问题回答，测试数据。问题回答，测试数据。问题回答，测试数据。'
        }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
.quesion-list {
  padding: 10px 20px;
  border-width: 0;

  .question-title {
    color: $base-red;
    font-weight: 700;
  }
  .question-answer {
    line-height: 24px;
  }
}
</style>
